import React from 'react';
import styled from 'styled-components';
import GeneraTabla from '../../components/Tablas';
import { useTranslate } from '../../contexts/languageContext';
import { Link } from 'react-router-dom';
import { getUrl } from '../../utils';
import constantes from '../../resources/constantes.json';
import { useIsDesktop } from '../../hooks/useMediaQuery';
//TODO: Caption

const TablaMunicipios = ({ tipoStats, data, nomenclator, elec }) => {
  const t = useTranslate();
  const isDesktop = useIsDesktop();

  const getDepartamento = (idamb, nomenclator, elec) => {
    const idDep = nomenclator.ambitos[elec][idamb].p[0];
    return nomenclator.ambitos[elec][idDep].n;
  };

  if (!data) return <div>No hay infomación</div>;
  return (
    <TablaSpread
      isDesktop={isDesktop}
      caption={<span className="visually-hidden">Tabla del ranking</span>}
      columns={{
        assets: {
          width: [25, 20, '', '', '', ''],
          align: ['start', 'start', 'end', 'end', 'end', 'end'],
          padding: [[0, 1.5], [0, 1.5], [0, 1.5], [0, 1.5], [0, 1.5], [0, 1.5]],
        },
        head: [
          {
            headers: ['', '', '', tipoStats],
            colSpan: ['', '', '', 3],
          },
          {
            headers: [
              t('municipio'),
              t(elec === "7" ? 'citrep' : 'departamento'),
              t('mesas') + ' ' + t('informadas'),
              '2022',
              '2018',
              '2014',
            ],
          },
        ],
        render: data => [
          <CeldaBigger>
            <SLink
              to={getUrl({
                id: data.idamb,
                eleccion: elec,
                page: constantes.nombreEleccion[elec],
                nomenclator,
              })}
            >
              {data.amb}
            </SLink>
          </CeldaBigger>,
          <CeldaBigger>
            <SLink
              to={getUrl({
                id: nomenclator.ambitos[elec][data.idamb].p[0],
                eleccion: elec,
                page: constantes.nombreEleccion[elec],
                nomenclator,
              })}
            >
              {getDepartamento(data.idamb, nomenclator, elec)}
            </SLink>
          </CeldaBigger>,
          data.pmesesc,
          data.pvot.act,
          data.pvot.ant,
          data.pvot.antant,
        ],
      }}
      data={data}
      hoverColor={'#faceb7'}
      oddStripesColor={'#f8f8f7'}
      tbodyRowHeight={'5em'}
      theadRowHeight={'4em'}
      cellTabindex={true}
    />
  );
};

export default TablaMunicipios;

const TablaSpread = styled(GeneraTabla)`
  width: 98%;
  border-spacing: 0;
  text-transform: uppercase;
  margin: ${({ isDesktop }) => !isDesktop && '0 auto'};
  & caption {
    text-align: left;
    line-height: 2em;
  }
  & thead th {
    font-weight: 800;
    color: #283f5f;
    position: sticky;
    top: 0;
    background: white;
  }
  & thead tr:first-child th {
    text-align: center;
  }
`;

const CeldaBigger = styled.span`
  font-size: 1.3rem;
`;

const SLink = styled(Link)`
  color: #222;
`;
